export enum PContextMenuPositionEnum {
  TOP_MIDDLE = 'top middle',
  TOP_START = 'top start',
  TOP_END = 'top end',
  CENTER_MIDDLE = 'center middle',
  CENTER_START = 'center start',
  CENTER_END = 'center end',
  BOTTOM_MIDDLE = 'bottom middle',
  BOTTOM_START = 'bottom start',
  BOTTOM_END = 'bottom end',
}

export type PContextMenuPosition =
  | PContextMenuPositionEnum.TOP_MIDDLE
  | PContextMenuPositionEnum.TOP_START
  | PContextMenuPositionEnum.TOP_END
  | PContextMenuPositionEnum.CENTER_MIDDLE
  | PContextMenuPositionEnum.CENTER_START
  | PContextMenuPositionEnum.CENTER_END
  | PContextMenuPositionEnum.BOTTOM_MIDDLE
  | PContextMenuPositionEnum.BOTTOM_START
  | PContextMenuPositionEnum.BOTTOM_END
